module.exports = __webpack_public_path__ + "img/icon-export-blue.8af2f817.svg";